import { ImgHTMLAttributes } from 'react'
import styles from './Image.module.css'
import { IMAGE_FALLBACK, resolveProductImage } from './resolveProductImage'

export type ImageProps = Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  'src' | 'alt' | 'srcSet' | 'sizes'
> & {
  mainPicture?: string
  mainPictureBig?: string
  src?: string
  alt: string
  priority?: boolean
  sizes?: string
  fallback?: string
}

export default function Image({
  mainPicture,
  mainPictureBig,
  src,
  alt,
  priority,
  sizes,
  fallback = IMAGE_FALLBACK,
  loading,
  fetchPriority,
  decoding = 'async',
  className,
  onError,
  ...rest
}: ImageProps) {
  const resolved = resolveProductImage({
    mainPicture,
    mainPictureBig,
    src,
    priority,
    fallback,
    sizes,
  })
  const slot = priority ? 'hero' : mainPicture || mainPictureBig ? 'card' : 'banner'

  return (
    <img
      {...rest}
      className={[styles.media, styles[slot], className].filter(Boolean).join(' ')}
      data-slot={slot}
      src={resolved.src}
      srcSet={resolved.srcSet}
      sizes={resolved.sizes}
      alt={alt}
      loading={loading ?? resolved.loading}
      fetchPriority={fetchPriority ?? resolved.fetchPriority}
      decoding={decoding}
      onError={event => {
        const target = event.currentTarget
        if (fallback && !target.src.endsWith(fallback)) {
          target.removeAttribute('srcset')
          target.src = fallback
        }
        onError?.(event)
      }}
    />
  )
}
